import TacosGraph from "@/components/brand_portfolio/TacosGraph";
import { EvolutionChartEngine } from "@/utils/dashboard/chart_engine";
export default {
  name: "Tacos",
  components: {
    TacosGraph
  },
  props: {
    tacosData: {
      type: Array,
      default: [],
      required: true
    },
    periodLength: {
      type: Number,
      default: 14
    },
    selected_period: {
      type: String,
      default: "14 days"
    },
    workspace_id: {
      type: String,
      default: ""
    },
    seller_id: {
      type: String,
      default: ""
    },
    hovering_workspace_id: {
      type: String,
      default: ""
    },
    hovering_seller_id: {
      type: String,
      default: ""
    },
    hovering_index: {
      type: Number,
      default: -1
    }
  },
  data() {
    return {
      chartEngine: null,
      defaultData: {
        label: null,
        evol_value: 0,
        kpi_value: 0
      }
    };
  },
  computed: {
    lastestValue() {
      return this.tacosData.length > 0 ? (this.tacosData[0]?.TACOS * 100).toFixed(0) : "-";
    },
    computedTacosData() {
      return [...this.tacosData].reverse();
    }
  },
  methods: {}
};